<template lang="pug">
  .dashboard(v-loading='isLoading' loading-spinner='circular')
    sub-header

    .container()
      chain-module

      div
        h3.tp-m-deci {{ this.$t('dashboard.businesses') }}
        commerce-module

    dialog-generic-error(
      :message='errorMessage'
      :dialog-error='dialogErrorHandle'
      :before-close-fn='handleCloseSession'
      @dialog-closed='closeDialogError($event)')

</template>

<script>
import SubHeader from '@/components/dashboard/SubHeader'
import ChainModule from '@/components/dashboard/ChainModule'
import CommerceModule from '@/components/dashboard/CommerceModule'
import { mapGetters } from 'vuex'
import { EventBusClickonChains } from '../events-bus'
import DialogGenericError from '@/components/dialogs/DialogGenericError'

export default {
  name: 'Home',

  components: {
    ChainModule,
    CommerceModule,
    SubHeader,
    DialogGenericError
  },

  data () {
    return {
      searched: '',
      selected: '',
      role: '',
      holding: '',
      emptyholding: {
        registro_Numero: 1,
        contcur: '',
        desholding: '',
        fecalta: '',
        fecbaja: '',
        holding: ''
      },
      dialogErrorHandle: false,
      hasErrors: false,
      errorMessage: ''
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      configFile: 'configFile'
    })
  },

  methods: {
    executeComercio () {
      this.$store.dispatch('listCommercial').then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in confirm token - App', e)
      })
    },
    executeCadena () {
      if (this.$store.getters.getListHoldingData !== '') {
        this.holding = this.$store.getters.getListHoldingData[0].holding
      } else {
      //  this.$store.dispatch('selectHolding', this.emptyholding)
      }
      this.$store.dispatch('listCommerce', this.holding).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          EventBusClickonChains.clickonChains()
          // this.executeComercio()
        }
      }).catch(e => {
        console.error('Error in confirm token - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.handleCloseSession()
      this.dialogErrorHandle = e
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogErrorHandle = true
    },
    getData () {
      const paramsPagina = JSON.stringify({
        pagina: 1
      })
      sessionStorage.setItem('appPagina', paramsPagina)
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      this.role = storageAppData.customer_role
      if (storageAppData.customer_role === '01' || storageAppData.customer_role.toString() === '99') {
        this.$store.dispatch('listHolding').then(r => {
          if (!r || (r && r.error === true)) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          } else {
            this.executeCadena()
          }
        }).catch(e => {
          // console.error('Error en listHolding- App', e)
        })
      } else if (storageAppData.customer_role === '02') {
        this.executeCadena()
      } else if (storageAppData.customer_role === '03') {
        this.executeComercio()
      } else {
        this.handleCloseSession()
      }
    },
    getInitialData () {
      this.getData()
    }
  },

  mounted () {
    if (this.configFile.endpoints) {
      this.getInitialData()
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  background-color: $--color-neutral-4;
  min-height: 100vh;
}

.container {
  padding: rem(24)
}
</style>
